// @flow
import React, { useContext } from 'react';
import { useFormikContext } from 'formik';
import { useParams } from 'react-router-dom';
import {
  useDisableStreamGovernanceWorkloadMutation,
  useEnableStreamGovernanceWorkloadMutation,
} from '@streaming-projects/service-definitions/streamingProjectsApi';
import { STREAM_GOVERNANCE_WORKLOADS_INPUTS_FIELDNAMES } from '@streaming-projects/orgs/enums';
import { CheckBoxField } from '@src/formik-utils/FormFields';
import { toastError } from '@presentational/notifications/utils';
import { SPStreamingProjectContext } from '@streaming-projects/sp-page/contexts/SPStreamingProjectContext';
import { STREAM_GOVERNANCE_WORKLOAD_DETAILS_CONFIG_MAP } from '@streaming-projects/workloads/stream-governance-workloads/config';

export const SPStreamGovernanceWorkloadEnabledContainer = ({
  streamGovernanceWorkloadId = null,
  streamGovernanceResourceId = null,
  checked = null,
  addLabel = true,
}) => {
  const { orgId, spId } = useParams();
  const { isValid } = useFormikContext();
  const spStreamingProjectData = useContext(SPStreamingProjectContext);

  const [enableWorkload] = useEnableStreamGovernanceWorkloadMutation();
  const [disableWorkload] = useDisableStreamGovernanceWorkloadMutation();

  const { backendFieldName, displayName, icon } = STREAM_GOVERNANCE_WORKLOAD_DETAILS_CONFIG_MAP.get(
    STREAM_GOVERNANCE_WORKLOADS_INPUTS_FIELDNAMES.IS_ENABLED
  );

  const checkedProps = checked != null ? { checked } : {};
  return (
    <CheckBoxField
      addLabel={addLabel}
      disabled={!isValid}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      icon={icon}
      onChange={async (event, value, setFieldValue, setFieldTouched, values, checked) => {
        const payload = {
          stream_governance_resource_id: streamGovernanceResourceId,
          sp_version: spStreamingProjectData?.sp?.version,
        };

        const funcToCall = checked ? enableWorkload : disableWorkload;

        const { error } = await funcToCall({
          orgId,
          spId,
          streamGovernanceWorkloadId,
          payload,
        });

        if (error) {
          toastError(error);
        }
      }}
      {...checkedProps}
    />
  );
};
